import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Tabs, Tab } from "@mui/material";
import DetailTop from "../../features/applicationDetail/topDetail";
import ApplicationDetail from "../../features/applicationDetail/basicDetail";
import ApplicationDocuments from "../../features/applicationDetail/documents";
import { useLazyApplicationDetailsQuery } from "../../service/applications";
import { ApplicationById } from "../../types/General";
import { errorToast } from "../../helpers";
import Loader from "../../constants/Loader";
import ApplicationPayments from "../../features/applicationDetail/payments";
import UpdateDays from "../../features/applicationDetail/updateDays";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ApplicationDetails = () => {
  const { type, id } = useParams();
  const navigate = useNavigate();

  const [applicationDetail] = useLazyApplicationDetailsQuery();

  const [loading, setLoading] = useState(false);
  const [applicationDetails, setApplicationDetails] =
    useState<ApplicationById | null>(null);

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const getApplicationDetails = async (id: number) => {
    setLoading(true);

    try {
      const response = await applicationDetail({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setApplicationDetails(response?.data);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getApplicationDetails(Number(id));
    }
  }, []);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title">
        <h1>Application Detail</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          Applications - Application Detail
        </p>
      </div>

      <DetailTop type={type} data={applicationDetails} />

      <Box className="custom_tabs2" sx={{ width: "100%" }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          aria-label="basic tabs example"
          className="custom_tabs_links"
        >
          <Tab label="Application Detail" {...a11yProps(0)} />
          <Tab label="Documents" {...a11yProps(1)} />
          <Tab label="Payments" {...a11yProps(2)} />
          <Tab label="Update no. of days for 2nd payment" {...a11yProps(2)} />
        </Tabs>
      </Box>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <ApplicationDetail type={type} data={applicationDetails} />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <ApplicationDocuments details={applicationDetails} />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <ApplicationPayments id={id} />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={3}>
          <UpdateDays id={id} data={applicationDetails} />
        </CustomTabPanel>
      </div>
    </MainContainer>
  );
};

export default ApplicationDetails;
